import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
enum CategoryFilterType {
    TEXT = "text",
    SELECT = "select",
    NUMBER = "number",
    BOOLEAN = "boolean",
    COLOR = "color",
    RATING = "rating",
    IMAGE = "image"
}

class Filter {
    id: string;
    name: string;
    type: CategoryFilterType = CategoryFilterType.SELECT;
}

class Option {
    id: string;
    value: string;
}

class Price  {
    id: string;
    price: number;
    price_with_off: number;
    option_id: string;
    option: Option;
}

export class GetInstanceProductPriceFormResponse {
    product_price_filters: Filter[];
    filter: Filter;
    prices: Price[];
}

export function getInstanceProductPriceForm(instance_id: number, product_id: string): Promise<AxiosResponse<GetInstanceProductPriceFormResponse>> {
    const path = `/instance/${instance_id}/product/${product_id}/price-filter`;
    return Cirus.get(path);
}

export function getInstanceProductFilterPriceForm(instance_id: number, product_id: string, filter_id: string): Promise<AxiosResponse<GetInstanceProductPriceFormResponse>> {
    const path = `/instance/${instance_id}/product/${product_id}/price-filter/${filter_id}`;
    return Cirus.get(path);
}